import { ServerSideRowModelModule } from "ag-grid-enterprise";
import { ModuleRegistry } from '@ag-grid-community/core';
import { observer } from "mobx-react";
import useStore from "../../../../store";
import { ServerGridConfig } from "../../../../config/GridConfig";
import { AgGridReact } from 'ag-grid-react';
import Message from '../../../../config/Message';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ListComponent = observer(() => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	dayjs.extend(utc);
	dayjs.extend(timezone);

	const { ENQUIRY } = useStore();

	const colDefs = [
		{
			headerName: 'Date',
			field: 'createdOn',
			minWidth: 100,
			sort: 'desc',
			valueFormatter: ({ value }) => {
				return value
					? dayjs.utc(value).tz('Asia/Kolkata').format('DD/MM/YYYY') : '';
			},
		},
		{
			headerName: 'Type',
			field: 'enquiryType',
			minWidth: 120,
		},
		{
			headerName: 'Name',
			field: 'name',
			minWidth: 100,
		},
		{
			headerName: 'Mobile No',
			field: 'mobileNumber',
			minWidth: 120,
		},
		{
			headerName: 'Email',
			field: 'email',
			minWidth: 50,
		},
		{
			headerName: 'City',
			field: 'city',
			minWidth: 100,
		},
		{
			headerName: 'Property Name',
			field: 'propertyName',
			minWidth: 100,
		},
		{
			headerName: 'Description',
			field: 'description',
			minWidth: 170,
			tooltipField: 'description',
		},


	];
	return (
		<div
			className="ag-theme-quartz"
			style={{ height: 'calc(100vh - 160px)' }}
		>
			<AgGridReact
				onGridReady={ENQUIRY.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
			/>
		</div>
	);
})

export default ListComponent;